import { isValidEmploymentVerificationCriteria } from "../../pages/adjudication/types/employment-verification-criteria-schema-v1";
import { isValidBasicCanadianCriminalRecordCriteria } from "../../pages/adjudication/types/basic-canadian-criminal-record-criteria-schema-v1";
import { RubricRuleset } from "./types";
import {
  BASIC_CANADIAN_CRIMINAL_RECORD_CHECK_TYPES,
  EMPLOYMENT_VERIFICATION_CHECK_TYPES,
} from "../../pages/adjudication/constants";

export function hasInvalidCriteria(ruleset: RubricRuleset): boolean {
  const isEmploymentVerification = EMPLOYMENT_VERIFICATION_CHECK_TYPES.includes(
    ruleset.check_type
  );

  const isBasicCanadianCriminalRecord =
    BASIC_CANADIAN_CRIMINAL_RECORD_CHECK_TYPES.includes(ruleset.check_type);

  if (isEmploymentVerification) {
    return !isValidEmploymentVerificationCriteria(ruleset.criteria);
  }

  if (isBasicCanadianCriminalRecord) {
    return !isValidBasicCanadianCriminalRecordCriteria(ruleset.criteria);
  }
  // For unsupported check types, always return true for invalid criteria
  return true;
}

export function shouldShowPreviewError(ruleset: RubricRuleset): boolean {
  const isEmploymentVerification = EMPLOYMENT_VERIFICATION_CHECK_TYPES.includes(
    ruleset.check_type
  );
  const isBasicCanadianCriminalRecord =
    BASIC_CANADIAN_CRIMINAL_RECORD_CHECK_TYPES.includes(ruleset.check_type);

  if (isEmploymentVerification || isBasicCanadianCriminalRecord) {
    return hasInvalidCriteria(ruleset);
  }

  // For unsupported check types, always show error
  return true;
}
